import { tns } from 'tiny-slider';
var TwoColumnImageSlider = /** @class */ (function () {
    function TwoColumnImageSlider(element) {
        this.imageSliderBlock = element;
        if (this.imageSliderBlock.querySelector('.slider-content') && this.imageSliderBlock.querySelector('.slider-content').childElementCount > 0) {
            // If Slider exists & slider contains any elements - initiate slider
            this.sliderContainer = this.imageSliderBlock.querySelector('.slider-content');
            this.initSlider();
        }
    }
    TwoColumnImageSlider.prototype.initSlider = function () {
        var slider = tns({
            container: this.sliderContainer,
            items: 1,
            slideBy: 1,
            loop: false,
            autoplay: false,
            controls: true,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
            responsive: {
                992: {
                    edgePadding: -90,
                    slideBy: 'page',
                    items: 2,
                    center: true,
                    nav: false,
                    controls: true,
                }
            },
        });
    };
    return TwoColumnImageSlider;
}());
var twoColumnImageSliderBlocks = document.querySelectorAll('[data-two-column-image-slider-block]');
twoColumnImageSliderBlocks.forEach(function (twoColumnImageSliderBlock) {
    new TwoColumnImageSlider(twoColumnImageSliderBlock);
});
